import { ContentLanguageLabelModel } from '@fi-shared/models';

export function fiTryContentLanguageValue(items: Array<ContentLanguageLabelModel>, languageId: number | string) {
    const item = fiTryContentLanguage<ContentLanguageLabelModel>(items, languageId);
    if (item) {
        return item.Value;
    }
    if (!items || !languageId) return undefined;

    for (let i = 0; i < items.length; i++) {
        if (items[i].ContentLanguageId == languageId) {
            return items[i].Value;
        }
    }
}

export function fiTryContentLanguage<T extends { ContentLanguageId: number }>(
    items: Array<T>,
    languageId: number | string,
): T {
    if (!items || !languageId) return undefined;

    for (let i = 0; i < items.length; i++) {
        if (items[i].ContentLanguageId == languageId) {
            return items[i];
        }
    }
}

export function getContentWithLanguage(
    Contents,
    languageId: number,
    defaultLanguage: number,
    defaultApplicationLanguage: number,
) {
    return (
        fiTryContentLanguageValue(Contents, languageId) ||
        fiTryContentLanguageValue(Contents, defaultLanguage) ||
        fiTryContentLanguageValue(Contents, defaultApplicationLanguage)
    );
}
